import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import moment from "moment"
import { Tooltip } from "@mui/material"
import { DetailSubsTasks } from "./DetailSubsTasks"
import NumberFormat from "react-number-format"
import { Tasks } from "../../../models/tasks"
import { Model } from "../../../models/model"
import { getNumberDays } from "../../../helpers/tasks"
import { BoxFlows } from "./BoxFlows"

// const statusList = [
//     { id: 'por hacer', nombre: 'por hacer' },
//     { id: 'en proceso', nombre: 'en proceso' },
//     { id: 'completado', nombre: 'completado' }
// ]

const statusList = [
    { id: 'por hacer', nombre: 'por hacer' },
    { id: 'en proceso', nombre: 'en proceso' },
    { id: 'completado', nombre: 'completado' },
    { id: 'stand-by', nombre: 'stand-by' }
]

// const priorityList = [
//     { id: 'critica', nombre: 'crítica' },
//     { id: 'alta', nombre: 'alta' },
//     { id: 'media', nombre: 'media' },
//     { id: 'baja', nombre: 'baja' }
// ]

export const DetailTasks = ({ currentTask, opens = null, usuariosTarea, handleRemoveTask, refreshObj, pathName, tarea_mostrar_horas }) => {
    const [listTask, setListTask] = useState(currentTask?.subs || [])

    useEffect(() => {
        setListTask(currentTask?.subs || [])
    }, [currentTask?.subs])

    const handleChangeNumberDays = async (values, item, targetName) => {
        if (!values.sourceInfo.event) return false

        const newStartDate = item?.fecha_inicio ? item?.fecha_inicio : new Date()
        const numberDays = getNumberDays(values.floatValue)
        const newEndDate = moment(newStartDate).add(numberDays, 'days').format('YYYY-MM-DD')

        const newForm = {
            ...item,
            dias: values.floatValue,
            fecha_inicio: newStartDate,
            fecha_fin: newEndDate,
            change_days: true,
            date_change_option: 'esta_tarea_posteriores'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: values.floatValue,
                    fecha_inicio: newStartDate,
                    fecha_fin: newEndDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChangeDateIni = async (newValue, item) => {
        const startDate = newValue.target.value
        const numberDays = getNumberDays(moment(startDate).diff(moment(startDate), 'days'))

        const newForm = {
            ...item,
            dias: numberDays,
            fecha_inicio: startDate,
            fecha_fin: startDate,
            edit_end_date: true,
            change_days: true,
            date_change_option: 'esta_tarea'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: numberDays,
                    fecha_inicio: startDate,
                    fecha_fin: startDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChangeDateFin = async (newValue, item = null) => {
        const endDate = newValue.target.value
        const startDate = item?.fecha_inicio ? item?.fecha_inicio : endDate
        const numberDays = getNumberDays(moment(endDate).diff(moment(startDate), 'days'))

        const newForm = {
            ...item,
            dias: numberDays,
            fecha_inicio: startDate,
            fecha_fin: endDate,
            edit_end_date: true,
            change_days: true,
            date_change_option: 'esta_tarea'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: numberDays,
                    fecha_inicio: startDate,
                    fecha_fin: endDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChangeTimes = async (values, item, targetName) => {
        if (!values.sourceInfo.event) return false

        const newForm = {
            ...item,
            [targetName]: values.floatValue
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return newForm
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

    }

    const handleRemoveTask_ = async (task) => {
        const tasksListUpdated = listTask?.filter(it => it.id !== task.id)
        setListTask(tasksListUpdated)

        await Model.delete({
            url: `tasks/proyectos/tasks2/${task.id}`
        })
    }

    const handleChangeName = async ({ target }, item) => {
        const newForm = {
            ...item,
            [target.name]: target.value
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    ...newForm
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

    }

    const handleChangeStatus = async ({ target }, item) => {

        const newForm = {
            ...item,
            [target.name]: target.value,
            change_state: true
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    ...newForm
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }


    return (
        <>
            {listTask?.map((it, index) => (
                <>
                    <tr
                        key={`tasks-${it.id}-${index}`}
                        className="text-center"
                        style={{
                            backgroundColor: '#f2e0f6',
                            color: it.estado === 'completado' ? 'green' : ''
                        }}
                    >
                        {pathName === 'tasks' ? <td></td> : ''}
                        <td colSpan={3} className="text-start">
                            <div className="d-flex justify-content-between align-items-center">
                                <Link
                                    to=""
                                    onClick={() => opens.handleOpenEdit(it?.id)}
                                    className={`d-flex justify-content-start align-items-center ms-2 
                                    ${it.estado === 'completado' ? 'p-link-tasks-done' : 'p-link-tasks'}`}
                                >
                                    <i className="bi bi-arrow-return-right" style={{ color: '#6610f2', fontSize: '14px' }}></i>
                                    <div
                                        className="ms-1"
                                        style={{
                                            fontSize: '13px',
                                            // color: '#6610f2',
                                            textAlign: 'left',
                                            color: it.estado === 'completado' ? 'green' : '#4a24ab',
                                            // textDecoration: it.estado === 'completado' ? 'line-through' : '',
                                            // textTransform: 'none'
                                        }}>
                                        {it?.prioridad === 'critica' ?
                                            <span style={{ color: 'red' }}>({it.orden}){' '}{it.nombre}</span>
                                            :
                                            <span>({it.orden}){' '}{it.nombre}</span>
                                        }
                                    </div>

                                    {it.estado === 'completado' ?
                                        <Tooltip title="Tarea completada">
                                            <i className="bi bi-check-circle-fill ms-1" style={{ fontSize: '14px' }}></i>
                                        </Tooltip> : ''
                                    }

                                </Link>

                                {it?.info_flow.length > 0 &&
                                    <Link
                                        to=""
                                        style={{ marginTop: '2px' }}
                                        className="p-link-hitos ms-2 d-flex justify-content-start align-items-end"
                                        onClick={() => opens.handleOpenEditFlow(it)}
                                    >
                                        <span className="d-flex flex-column justify-content-start align-items-end mt-2">
                                            {it?.info_flow.map(itf => <BoxFlows flow={itf} />)}
                                        </span>
                                    </Link>
                                }

                            </div>
                            <div className="ms-4">
                                {it.subs?.length > 0 ?
                                    <Link to="" onClick={() => opens?.handleOpenSubs(it.id, it.id_hito)}>
                                        <i className="bi bi-list-check ms-1" style={{ fontSize: '14px' }}></i>
                                        <span style={{ fontSize: '11px', marginLeft: '2px' }}>{it.subs?.length} subtareas</span>
                                    </Link> : ''
                                }
                                {it?.cant_comentarios > 0 ?
                                    <span className={it.subs?.length > 0 ? 'ms-3' : ''}>
                                        <i className="bi bi-chat-left-dots" style={{ fontSize: '12px' }}></i>
                                        <span className="ms-1" style={{ fontSize: '11px' }}>{it?.cant_comentarios || 0} comentarios</span>
                                    </span> : ''
                                }
                            </div>
                        </td>
                        <td className="p-va">
                            {/* {!it?.subs?.length > 0 ? */}
                            <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '2px',
                                    backgroundColor: 'white',
                                    width: '60px',
                                    borderRadius: '3px'
                                }}
                                name="id_responsable"
                                onChange={(e) => handleChangeName(e, it)}
                                disabled={it?.subs?.length > 0}
                            >
                                <option key="" value="">--</option>
                                {usuariosTarea?.map(ut => (
                                    <option
                                        key={ut.id}
                                        selected={ut.id === it?.id_responsable ? 'selected' : ''}
                                        value={ut.id}
                                    >
                                        {ut.nombre}
                                    </option>
                                ))}
                            </select>
                            {/* : ''
                            } */}
                        </td>
                        <td className="p-va">
                            {/* {!it?.subs?.length > 0 ? */}
                            <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '2px',
                                    backgroundColor: 'white',
                                    width: '60px',
                                    borderRadius: '3px'
                                }}
                                name="id_responsable_seguimiento"
                                onChange={(e) => handleChangeName(e, it)}
                                disabled={it?.subs?.length > 0}
                            >
                                <option key="" value="">--</option>
                                {usuariosTarea?.map(ut => (
                                    <option
                                        key={ut.id}
                                        selected={ut.id === it?.id_responsable_seguimiento ? 'selected' : ''}
                                        value={ut.id}
                                    >
                                        {ut.nombre}
                                    </option>
                                ))}
                            </select>
                            {/* : ''
                            } */}
                        </td>

                        {tarea_mostrar_horas ?
                            <>
                                <td>
                                    <div style={{ textAlign: 'center', marginTop: '13px' }}>
                                        {it?.subs?.length > 0 ?
                                            <NumberFormat
                                                displayType={'text'}
                                                className="text-end"
                                                value={it.hora_estimada || 0}
                                                thousandSeparator=','
                                                decimalSeparator='.'
                                                suffix=" hrs."
                                                decimalScale={2}
                                                fixedDecimalScale={0}
                                            />
                                            :
                                            <NumberFormat
                                                className="text-end p-cantidades-item-new22"
                                                style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                                                name="hora_estimada"
                                                value={it?.hora_estimada || 0}
                                                thousandSeparator=','
                                                decimalSeparator='.'
                                                suffix=" hrs."
                                                decimalScale={2}
                                                fixedDecimalScale={0}
                                                onValueChange={(values, sourceInfo) => handleChangeTimes({ ...values, sourceInfo }, it, 'hora_estimada')}
                                            />
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div style={{ textAlign: 'center', marginTop: '13px' }}>
                                        {it?.subs?.length > 0 ?
                                            <NumberFormat
                                                displayType={'text'}
                                                className="text-end"
                                                value={it.hora_real || 0}
                                                thousandSeparator=','
                                                decimalSeparator='.'
                                                suffix=" hrs."
                                                decimalScale={2}
                                                fixedDecimalScale={0}
                                            />
                                            :
                                            <NumberFormat
                                                className="text-end p-cantidades-item-new22"
                                                style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                                                name="hora_real"
                                                value={it?.hora_real || 0}
                                                thousandSeparator=','
                                                decimalSeparator='.'
                                                suffix=" hrs."
                                                decimalScale={2}
                                                fixedDecimalScale={0}
                                                onValueChange={(values, sourceInfo) => handleChangeTimes({ ...values, sourceInfo }, it, 'hora_real')}
                                            />
                                        }
                                    </div>
                                </td>

                            </>
                            : ''
                        }

                        <td className="text-center">
                            {it?.subs?.length > 0 ?
                                <div style={{ textAlign: 'center', marginTop: '13px' }}>
                                    <NumberFormat
                                        displayType={'text'}
                                        className="text-end"
                                        value={it.dias || 0}
                                        thousandSeparator=','
                                        decimalSeparator='.'
                                        suffix=" días"
                                        decimalScale={0}
                                        fixedDecimalScale={0}
                                    />
                                </div>
                                :
                                <div style={{ marginTop: '10px' }}>
                                    <NumberFormat
                                        className="text-end p-cantidades-item-new22"
                                        style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                                        name="dias"
                                        value={it.dias || 0}
                                        thousandSeparator=','
                                        decimalSeparator='.'
                                        suffix=" días"
                                        decimalScale={0}
                                        fixedDecimalScale={0}
                                        onValueChange={(values, sourceInfo) => handleChangeNumberDays({ ...values, sourceInfo }, it, 'dias')}
                                    />
                                </div>
                            }
                        </td>
                        <td className="p-va">
                            {it?.subs?.length > 0 ?
                                <span>{it?.fecha_inicio ? moment(it?.fecha_inicio).format('DD-MM-YYYY') : '---'}{' '}</span>
                                :
                                <input
                                    style={{ padding: '2px', borderRadius: '3px' }}
                                    type="date"
                                    value={moment(it?.fecha_inicio).format('YYYY-MM-DD')}
                                    onChange={(value) => handleChangeDateIni(value, it)}
                                />
                            }

                        </td>
                        <td className="p-va">
                            <div className="d-flex justify-content-end align-items-center">
                                {it?.subs?.length > 0 ?
                                    <div>{it?.fecha_fin ? moment(it?.fecha_fin).format('DD-MM-YYYY') : '---'}{' '}</div>
                                    :
                                    <input
                                        style={{
                                            padding: '2px',
                                            borderRadius: '3px',
                                            border: 'none'
                                        }}
                                        type="date"
                                        value={moment(it?.fecha_fin).format('YYYY-MM-DD')}
                                        onChange={(value) => handleChangeDateFin(value, it)}
                                    />
                                }
                            </div>

                        </td>
                        <td className="p-va">
                            {it?.subs?.length > 0 ?
                                <div style={{
                                    color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
                                    textTransform: 'uppercase',
                                    fontSize: '10px'
                                }}>
                                    {it?.estado || '--'}
                                </div>
                                :
                                <select
                                    style={{
                                        border: '1px solid lightgray',
                                        padding: '2px',
                                        fontSize: '10px',
                                        backgroundColor: 'white',
                                        textTransform: 'uppercase',
                                        borderRadius: '3px',
                                        color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
                                    }}
                                    name="estado"
                                    onChange={(e) => handleChangeStatus(e, it)}
                                >
                                    <option key="" value="">--</option>
                                    {statusList?.map(es => (
                                        <option
                                            key={es.id}
                                            selected={es.id === it?.estado ? 'selected' : ''}
                                            value={es.id}
                                        >
                                            {es.nombre}
                                        </option>
                                    ))}
                                </select>
                            }
                        </td>
                        <td className="p-va">
                            {!it?.info_flow?.id ?
                                < Tooltip title="Eliminar tarea">
                                    <Link to="" onClick={() => handleRemoveTask_(it)}>
                                        <i className="bi bi-trash" style={{ color: 'gray', fontSize: '14px' }}></i>
                                    </Link>
                                </Tooltip> : ''
                            }
                        </td>
                    </tr >
                    {it?.show_subs ?
                        <DetailSubsTasks
                            currentTask={it}
                            opens={opens}
                            usuariosTarea={usuariosTarea}
                            refreshObj={refreshObj}
                            pathName={pathName}
                            tarea_mostrar_horas={tarea_mostrar_horas}
                        /> : ''
                    }

                </>
            ))
            }
        </>

    )
}
